<template>
<section class="mb-5">
    <h3 class="section-title">Recent Publications</h3>
    <ul class="right-list">
        <div>
            
            <ul class="tech-list">
                <li style="margin-right: 0.5rem; margin-bottom: 0.5rem" v-for="(publication,index) in publicationInfo" :key="index">
                    <!-- {{ "·" }} -->
                    <span style="font-style: oblique;">{{publication.authors}}</span>
                    {{"(" + publication.year +") -"}}
                    {{publication.title}}
                    <span style="font-style: italic;">{{publication.meta}}</span>
                </li>
            </ul>
        </div>
    </ul>
</section>
</template>

<script>
export default {
    props:{
        publicationInfo:{
            type: Object
        }
    }
}
</script>

<style>

</style>
